import { Pipe, PipeTransform } from '@angular/core';
import { lowerCase, upperFirst } from 'lodash';

@Pipe({
  name: 'humanize'
})
export class HumanizePipe implements PipeTransform {
  transform(value: string, args?: any): any {
    return lowerCase(value).split(' ').map(word => upperFirst(word)).join(' ');
  }
}
